import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SHARED_ENVIRONMENT } from '@cp/shared/environment/environment.token';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Environment } from '@cp/shared/environment/environment.interface';
import { SharedHttpService } from '../../shared/shared-http.service';
import { LogInTargetHttpPaths } from './log-in-target-http.paths';

@Injectable({
  providedIn: 'root',
})
export class LogInTargetService extends SharedHttpService {
  public lastLoggedIn$: Observable<HttpResponse<void>> = this._http.put<void>(
    this._environment.apiEndpoint + LogInTargetHttpPaths.lastLoggedIn,
    undefined,
    {
      observe: 'response',
    },
  );

  constructor(
    private _http: HttpClient,
    @Inject(SHARED_ENVIRONMENT)
    private _environment: Environment,
  ) {
    super();
  }
}
